<template>
    <div class="login-view overflow-hidden">
        <div class="login-horse-types w-full flex gap-8 justify-content-center relative">
            <div class="login-horse-arabian arab-horses flex flex-column align-items-center p-6 cursor-pointer">
                <h2>{{ $t('message.login.loginHeaderArabianTwo') }}</h2>
                <div class="logo-and-form flex gap-4">
                    <img class="arabian-logo" src="../assets/arabianLogo.png" alt="National Center For The Arabian Horse Logo" />
                    <LoginForm name="arabian" horseBreed="ARABIAN" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginForm from "./LoginForm.vue";

    export default {
        name: "LoginView",
        components: {
            LoginForm,
        },

        data() {
            return {
                horseType: 'arabian',
            };
        },

        mounted() {
            document.querySelector(".login-horse-arabian").classList.add("active");
            document.querySelector(".login-horse-arabian").classList.remove("hide");
        },
    };
</script>

<style lang="scss">
    @import "assets/scss/login";
    @import "../assets/theme/mytheme/variables";

    .login-view {
        .custom-input-text, .custom-password {
            padding-left: 50px;
            input {
                background-color: var(--text-light-color);
            }
            .custom-label {
                text-align: right;
                z-index: 999;
                position: absolute;
                transform: translateX(-100%);
                left: 40px;
            }
        }
        .login-button {
            left: 80px;
        }
        .custom-text-button {
            margin-bottom: 0.5rem;
            label {
                font-weight: 400;
                font-size: 13px;
            }
        }
    }
</style>
